import { X } from 'lucide-react-native';
import { twJoin } from 'tailwind-merge';

import { Heading } from '@/components/ui/heading';
import { HStack } from '@/components/ui/hstack';
import { Icon } from '@/components/ui/icon';
import { Pressable } from '@/components/ui/pressable';

type MobileSheetHeaderProps = {
  title: string;
  onClose: () => void;
  className?: string;
  titleClassName?: string;
  titleSize?: 'md' | 'h2-md' | 'h2-xl';
  closeIconSize?: 'sm' | 'md';
};

export function MobileSheetHeader({
  title,
  onClose,
  className,
  titleClassName,
  titleSize = 'md',
  closeIconSize = 'md',
}: MobileSheetHeaderProps) {
  return (
    <HStack className={twJoin('items-center justify-between', className)}>
      <Heading size={titleSize} className={titleClassName}>
        {title}
      </Heading>
      <Pressable
        onPress={onClose}
        className="h-8 w-8 items-center justify-center rounded-full"
        accessibilityLabel="Close">
        <Icon as={X} size={closeIconSize} className="text-typography-500" />
      </Pressable>
    </HStack>
  );
}
